import type { ReactNode } from 'react'

import { useAppRouter as useRouter } from '@/shared/hooks/useAppRouter'

import { isMobileOnly } from 'react-device-detect'

import { LayoutBottomNav } from './chrome/BottomNav'
import { RewardGainBadgeHost } from './chrome/RewardGainBadgeHost'
import { StoreNudgeHost } from './chrome/StoreNudgeHost'
import { LayoutHeader, type TopbarVariant } from './chrome/TopBar'
import { AppMenu } from './menu'
import { AppPage } from './shells/AppPage'
import { GameShell } from './shells/GameShell'
import {
  isLevelPlayRoute,
  PassthroughShell
} from './shells/PassthroughShell'
import { isAvatarEditorRoute } from '@/shared/lib/routing/account'

type LayoutProps = {
  children: ReactNode
  topbarVariant?: TopbarVariant
}

// `topbarVariant` sem default: repassar `undefined` deixa o `LayoutHeader`
// derivar a variante da IDV do evento. Passar 'clean' aqui sobrescreveria essa
// derivação em toda rota e a topbar nunca sairia do preset claro.
export const Layout = ({ children, topbarVariant }: LayoutProps) => {
  const router = useRouter()
  const isLevelPlay = isLevelPlayRoute(router.pathname)
  const isMyAvatar = isAvatarEditorRoute(router.pathname)
  const hideNavigations = isMobileOnly && isMyAvatar

  if (isLevelPlay) {
    return <PassthroughShell>{children}</PassthroughShell>
  }

  return (
    <>
      <GameShell>
        {!hideNavigations && (
          <GameShell.TopBar>
            <LayoutHeader variant={topbarVariant} />
          </GameShell.TopBar>
        )}

        <GameShell.Page>
          <AppPage>{children}</AppPage>
        </GameShell.Page>

        {!hideNavigations && (
          <GameShell.BottomNav>
            <LayoutBottomNav />
          </GameShell.BottomNav>
        )}

        {/* Fora de `GameShell.Page` de propósito: troca de rota remonta a
            página, e a fila de badges não pode reiniciar no meio de um lote. */}
        {!hideNavigations && <RewardGainBadgeHost />}
        {!hideNavigations && <StoreNudgeHost />}
      </GameShell>

      <AppMenu />
    </>
  )
}
